import Vue, { DirectiveOptions, DirectiveFunction, VNode } from 'vue'
import { DirectiveBinding } from 'vue/types/options'
import { find } from 'lodash'
import { VNodeDirective } from 'vue/types/vnode'
import { masker } from '@/utils'

function event(name: string) {
  const evt = document.createEvent('Event')
  evt.initEvent(name, true, true)
  return evt
}

const bind: DirectiveFunction = (
  el: HTMLElement,
  binding: DirectiveBinding,
  vnode: VNode
) => {
  if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
    const els = el.getElementsByTagName('input')
    if (els.length !== 1) {
      throw new Error('v-mask directive requires 1 input, found ' + els.length)
    } else {
      el = els[0]
    }
  }

  let model: VNodeDirective | undefined
  if (vnode.data !== undefined) {
    model = find(vnode.data.directives, (directive: VNodeDirective) => {
      return directive.name === 'model'
    })
  }

  const name = model ? model.expression : ''

  el.oninput = (e: any) => {
    if (!e.isTrusted) return

    const config = e.target.dataset.config

    const value = config ? masker(e.target.value, config, true) : e.target.value

    // 入力値と修正値が同一ならinputイベントは起こさない
    if (value === e.target.value) return

    if (name) {
      if (vnode.context !== undefined) {
        Vue.set(vnode.context, name, value)
      }
    } else {
      e.target.value = value
    }

    el.dispatchEvent(event('input'))
  }

  el.dataset.config = binding.value
}

const update: DirectiveFunction = (
  el: HTMLElement,
  binding: DirectiveBinding
) => {
  const config = binding.value
  if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
    const els = el.getElementsByTagName('input')
    if (els.length !== 1) {
      throw new Error('v-mask directive requires 1 input, found ' + els.length)
    } else {
      el = els[0]
    }
  }
  el.dataset.config = config
}

export const InputMask: DirectiveOptions = {
  bind,
  update
}
